<template>
  <div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Sort</label>
      </div>
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="sort" @change="load">
                <option v-for="s in sorts" :value="s">{{s.name}} {{s.lorder}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="table is-fullwidth is-size-7 is-hoverable">
      <thead>
        <tr>
          <th>Pin</th>
          <th>Branch</th>
          <th>Is demo</th>
          <th>Attached to</th>
          <th>Value</th>
          <th>Created</th>
          <th>Activated</th>
          <th>Description</th>
          <th>Created for</th>
          <th>Activated for</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pin in pins">
          <td>
            <span :class="{'has-text-success':!pin.activated && !pin.deactivated, 'has-text-grey has-text-line-through':pin.activated, 'has-text-danger has-text-line-through':pin.deactivated}">{{pin.pin}}</span>
          </td>
          <td>
              {{pin.branch}}
          </td>
          <td>
            <span class="tag" v-if="pin.isDemo">demo</span>
          </td>
          <td>
            <span v-if="pin.attachedToName">{{pin.attachedToName || '[not attached]'}}</span>
            <span v-if="!pin.attachedToName" class="icon is-small" title="Pin does not attached to any player">
              <i class="fas fa-lock-open has-text-grey-light"></i>
            </span>
          </td>
          <td>{{pin.value | currency(pin.currency)}}</td>
          <td>
            {{pin.created | datetime}}
            by
            <router-link :to="{ name: 'player', params: { clientId: clientId, playerId: pin.createdBy } }">{{ pin.createdByName }}</router-link>
          </td>
          <td>
            <span v-if="pin.activated">
              {{pin.activated | datetime}}
              by
              <router-link :to="{ name: 'player', params: { clientId: clientId, playerId: pin.activatedBy } }">{{ pin.activatedByName }}</router-link>
            </span>
          </td>
          <td>{{pin.site}} - {{pin.description}}</td>
          <td>
            <span class="tag" :class="{'is-danger':pin.createdFor == 'Withdraw', 'is-success':pin.createdFor == 'Deposit'}">{{pin.createdFor}}</span>
          </td>
          <td>
            <span class="tag" :class="{'is-danger':pin.activatedFor == 'Withdraw', 'is-success':pin.activatedFor == 'Deposit'}">{{pin.activatedFor}}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <pagination @change="load();" ref="pagination" />
  </div>
</template>
<script>
  import pagination from './pagination.vue'

  export default {
    name: 'pin-list',
    components: { pagination },
    props: {
      dataFunc: {
        required: true,
        type: Function
      }
    },
    data() {
      return {
        pins: [],
        sorts: [
          { field: "_c", name: "Created", order: "Ascending", lorder: "asc." },
          { field: "_c", name: "Created", order: "Descending", lorder: "desc." },
          { field: "_a", name: "Activated", order: "Ascending", lorder: "asc." },
          { field: "_a", name: "Activated", order: "Descending", lorder: "desc." }
        ],
        sort: null
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    created() {
      this.sort = this.sorts[3];
    },
    methods: {
      async load() {
        const filter = {
          pageNumber: this.$refs.pagination.pageNumber,
          pageSize: this.$refs.pagination.pageSize,
          sortBy: this.sort.field,
          sortOrder: this.sort.order,
        };
        const data = await this.dataFunc(filter);
        this.pins = data.items;
        this.$refs.pagination.set(data.pageNumber, data.totalPages);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/common/pin-list.vue